export { default } from "./InnerHTML";
